import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

export function ValidationDialog({
  open,
  onClose,
  errors,
  showProceed,
  onProceed,
}: {
  open: boolean;
  onClose: () => void;
  errors: string[];
  showProceed?: boolean;
  onProceed?: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="val-dialog-title"
      PaperProps={{ sx: { width: "80%" } }}
    >
      <DialogTitle
        id="val-dialog-title"
        sx={{
          color: showProceed ? "warning.main" : "error.main",
          fontWeight: "bold",
        }}
      >
        {showProceed ? "Aviso: Parcelas no mesmo mês" : "Erro no Cadastro"}
      </DialogTitle>

      <DialogContent dividers>
        <List dense>
          {errors.map((e, i) => (
            <ListItem key={i} disableGutters>
              <ListItemText primary={e} />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {/* LÓGICA DOS BOTÕES */}
        {showProceed ? (
          <>
            {/* Se for aviso, mostra os dois botões */}
            <Button onClick={onClose} color="inherit" variant="outlined">
              Cancelar
            </Button>
            <Button onClick={onProceed} variant="contained" color="success">
              Prosseguir assim mesmo
            </Button>
          </>
        ) : (
          /* Se for erro impeditivo, mostra apenas um botão de fechar */
          <Button onClick={onClose} variant="contained" color="primary">
            Ok
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
